import styled from 'styled-components';

export const SearchChatsZone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  position: relative;
`;

export const SearchChatsInput = styled.input`
  padding: 1rem 3rem 1rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  width: 100%;
  height: 40px;
  outline: none;
  transition: box-shadow 0.3s ease, background 0.3s ease, border 0.3s ease;
  font-weight: 600;
  font-size: 15px;

  border: 0.12rem solid ${(props) => (props.withData ? '#1890ff' : 'lightgray')};
  background: ${(props) => (props.withData ? '#e6f7ff' : '#fff')};
  color: ${(props) => (props.withData ? '#222' : '#33333380')};
  box-shadow: ${(props) => (props.withData ? '0 0 0 2px #1890ff33' : 'none')};
  &::placeholder {
    color: #33333390;
    font-weight: 400;
  }
`;

export const CheckboxChat = styled.input`
  position: absolute;
  z-index: 100000;
  top: 108px;
  left: 33px;
  border: 1px solid #ccc;
  width: 16px;
  height: 16px;
  border-radius: 10px;
`;

export const OrderChatWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.6rem;
  flex-direction: row;
  gap: 0.5rem;
`;

export const SearchButton = styled.div`
  background-color: ${(props) => props.bgColor || 'gray'};
  opacity: 0.8;
  border-radius: 0.5rem;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  position: absolute;
  right: ${(props) => props?.right || '5.35rem;'};
  cursor: pointer;
  transition: opacity 0.3s ease;
  margin-left: 0.5rem;

  &:hover {
    opacity: 1;
  }
`;

export const Divider = styled.div`
  background-color: lightgray;
  width: 1px;
  height: 30px;
  margin: 0 1rem;
`;
